import './Mission.scss'

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { parseISO, isAfter } from 'date-fns';
import Edit from 'react-feather/dist/icons/edit.js';
import Trash from 'react-feather/dist/icons/trash.js';
import ChevronDown from 'react-feather/dist/icons/chevron-down.js';
import ChevronUp from 'react-feather/dist/icons/chevron-up.js';

import connectModal from '../../../../../shared/components/Modals/connect.js';
import Date from '../../../../../shared/components/Moment/Date.jsx';
import MissionModal from '../../../Modals/Mission/MissionModal.jsx';
import DeleteMissionModal from '../../../Modals/Mission/DeleteMissionModal.jsx';
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx";
import connect from "react-redux/lib/connect/connect.js";
import {isAdmin} from "../../../../../shared/services/userService.js";

class Mission extends Component {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      experiences: this.getSortedMissions(this.props.freelance?.experiences?.length ? this.props.freelance.experiences : []),
      experiencesVisibility: []
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const prevExperiences = prevProps.freelance?.experiences?.length ? prevProps.freelance.experiences : [];
    const experiencesProps = this.props.freelance?.experiences?.length ? this.props.freelance.experiences : [];

    if (this.props.freelance.id !== prevProps.freelance.id || prevExperiences !== experiencesProps) {
      this.setState({
        experiences: this.getSortedMissions(this.props.freelance?.experiences?.length ? this.props.freelance.experiences : [])
      });
    }
  }

  getSortedMissions = (experiences) => {
    return experiences
      .sort((a, b) => {
        if (a.current && !b.current) {
          return -1;
        }

        if (b.current && !a.current) {
          return 1;
        }

        const dateA = parseISO(a.start);
        const dateB = parseISO(b.start);
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1;
          } else {
            return 1;
          }
        } else {
          return 0;
        }
      });
  };

  editExistingMission = (offset) => {
    this.props.openMissionModal({
      freelance: this.props.freelance,
      experiences: this.state.experiences,
      onClose: this.onClose,
      onSubmit: this.props.submit,
      offset
    });
  };

  deleteMission = (offset) => {
    this.props.openDeleteMissionModal({
      freelance: this.props.freelance,
      experiences: this.state.experiences,
      onClose: this.onClose,
      offset
    });
  };

  onClose = (exp) => {
    this.setState({experiences: this.getSortedMissions(exp)});
  };

  toggle = (offset) => {
    const {experiencesVisibility} = this.state

    const currentVisibility = (experiencesVisibility[offset])
      ? experiencesVisibility[offset]
      : false

    const currentExperiencesVisibility = experiencesVisibility
    currentExperiencesVisibility[offset] = !currentVisibility

    this.setState({
      experiencesVisiblity: [
        ...currentExperiencesVisibility
      ]
    })
  }

  isVisible = (offset) => {
    const {isAdmin} = this.props
    const {experiencesVisibility} = this.state

    const isVisible =  (experiencesVisibility[offset])
      ? experiencesVisibility[offset]
      : false

    return isAdmin
      ? !isVisible
      : isVisible
  }

  render() {
    const { experiences } = this.state

    return (
      <div>
        {experiences.map((experience, offset) => (
          <div
            className={this.props.className}
            id={`experiences-${offset}`}
            key={`experience-${offset}`}
          >
            {this.props.canEdit ?
              <CardRow justify="flex-end" gap="10px">
                <div
                  onClick={() => this.toggle(offset)}
                  className="btn btn btn-outline-secondary btn-round btn-sm"
                >
                  {this.isVisible(offset)? <ChevronDown /> : <ChevronUp/> }
                </div>
                <div
                  onClick={() => this.editExistingMission(offset)}
                  className="btn btn btn-outline-primary btn-round btn-sm"
                >
                  <Edit />
                </div>
                <div
                  onClick={() => this.deleteMission(offset)}
                  className="btn btn btn-outline-danger btn-round btn-sm"
                >
                  <Trash />
                </div>
              </CardRow>
              : ''
            }
            {(experience.title || experience.locality || experience.company) &&
              <div className="break-inside">
                <h3 className="sub-sub-title">{experience.title}</h3>
                {experience.title && experience.company && <span> chez </span>}
                {experience.company && <b>{experience.company}</b>}
                {(experience.company || experience.title) && experience.locality && <span> - </span>}
                {experience.locality && <span>{experience.locality}</span>}
              </div>
            }
            {(experience.start || experience.end || experience.current) &&
            <div className="break-inside">
              {(experience.start && <Date format="MM/yyyy" date={experience.start} />)}
              {(experience.start && (experience.current || experience.end) && <span> - </span>)}
              {(experience.current
                ? <span>Aujourd'hui</span>
                : (experience.end && <Date format="MM/yyyy" date={experience.end} />)
              )}
            </div>
            }
            <div
              className={`
                mission-description
                ${(experience.start || experience.end || experience.current || experience.title || experience.locality || experience.company) ? 'mt-2 ' : ''}
                ${this.isVisible(offset)? 'visible': 'hide-for-desktop'}
              `}
              dangerouslySetInnerHTML={{__html: experience.description}}>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default  connect(
  state => ({
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(connectModal({ MissionModal, DeleteMissionModal }, Mission));